﻿import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
import { Polygon, MultiPolygon, LineString, MultiLineString, Point, MultiPoint, GeometryCollection } from 'ol/geom.js';
import TileWMSSource from 'ol/source/TileWMS.js';
import ImageWMSSource from 'ol/source/ImageWMS.js';
import ImageSource from 'ol/source/Image.js';
import TileLayer from 'ol/layer/Tile.js';
import ImageLayer from 'ol/layer/Image.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import Feature from 'ol/Feature.js';
import Overlay from 'ol/Overlay.js';
import { Utility } from '../Utility.js';
export { NetworkSimulationTool };

/**
 * Class Network Simulation tool
 */
const NetworkSimulationTool = function ()
{
    // Define this
    var myNetworkSimulationTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Already initialize
    this._toolInitialize = false;

    // Edge identifier selected
    this._idEdgeSelected = null;

    // Define source layer for edge selected
    this._sourceLayerSelected = new VectorSource();

    // Position layer select in map array layer
    this._layerSelectPosLayer = -1;

    // Layer info valve and source
    this._layerInfoElementToClose = {};

    // Utility
    this._utility = new Utility();

    //Layer Info to create datatable
    this._layerCreateDatatable = null;

    // Style for selected feature
    this._edgeStylesSelected = [
        new Style({
            image: new CircleStyle({
                radius: 10,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 0, 0.5)',
                    width: 5
                }),
                fill: new Fill({
                    color: 'rgba(0, 0, 255, 0.2)'
                })
            }),
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 0.5)',
                width: 10
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 255, 0.5)'
            })
        })
    ];

    // Valve highlight style
    this._valveHighlighStyles = [
        new Style({
            image: new CircleStyle({
                radius: 7,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 0, 0.7)',
                    width: 5
                }),
                fill: new Fill({
                    color: 'rgba(0, 0, 255, 0.2)'
                })
            }),
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 0.2)',
                width: 14
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 255, 0.2)'
            })
        })
    ];

    // Service pipe selected highlight style
    this._servicePipeStyle = [
        new Style({
            stroke: new Stroke({
                color: 'rgba(235, 158, 52, 0.7)',
                width: 6
            }),
            fill: new Fill({
                color: 'rgba(235, 158, 52, 0.1)'
            })
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(235, 158, 52, 0.7)',
                width: 4
            }),
            fill: new Fill({
                color: 'rgba(235, 158, 52, 0.1)'
            })
        })
    ];

    // Pipe highlight style
    this._pipeStyle = [
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 250, 0, 0.3)',
                width: 6
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 255, 0.1)'
            })
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 200, 0, 0.5)',
                width: 4
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 255, 0.1)'
            })
        })
    ];

    // Valve highlight style
    this._valveStyle =
        new Style({
            image: new Icon({
                anchor: [0.5, 11],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                scale: 0.7,
                src: 'images/cadastro_valvula_highlight.svg'
            })
        });

    // Consumption point highlight style
    this._consumptionPointStyle = [
        new Style({
            image: new CircleStyle({
                radius: 7,
                stroke: new Stroke({
                    color: 'rgba(252, 0, 0, 0.7)',
                    width: 2
                }),
                fill: new Fill({
                    color: 'rgba(0, 0, 255, 0.1)'
                })
            })
        }),
        new Style({
            image: new CircleStyle({
                radius: 9,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 0.7)',
                    width: 2
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.1)'
                })
            })
        })
    ];

    // Style point cut
    this._stylePointCut = [
        new Style({
            image: new CircleStyle({
                radius: 7,
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 1)'
                }),
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2
                }),
            })
        }),
        new Style({
            image: new CircleStyle({
                radius: 5,
                stroke: new Stroke({
                    color: 'rgba(0, 0, 0, 1)',
                    width: 2
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 0, 1)',
                })
            })
        })
    ];

    // -- end private variable --------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------
    // -- end public variable ---------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Menu definition
     */
    this.BuildMenuBar = function ()
    {
        // -- Select edge -------------------------------------------------------------------------
        const buttonSelect = document.createElement('li');

        const buttonSelectContainer = document.createElement('a');
        buttonSelectContainer.setAttribute('href', '#id-target-gpi-select-cut');
        buttonSelectContainer.id = 'id-target-gpi-select-cut';
        buttonSelectContainer.className = 'target';
        buttonSelectContainer.setAttribute('title', 'Selecionar');

        const buttonSelectContent = document.createElement('div');
        buttonSelectContent.className = 'menu-icon';
        buttonSelectContent.innerHTML = '<i class="gpi gpi-selecionar"></i>';

        buttonSelectContainer.appendChild(buttonSelectContent);
        buttonSelect.appendChild(buttonSelectContainer);

        /**
         * Select Handle
         */
        const handleSelect = function () {
            myNetworkSimulationTool._mapSgs._utility.HoldButtonEffect('main-menu-network-simulation-tool', 'id-target-gpi-select-cut');

            if (!$(this).find('a').hasClass('hold-button')) { // Reset select

                // Remove select edge click
                myNetworkSimulationTool._mapSgs.map.un('singleclick', myNetworkSimulationTool._SelectEdge);

                // Active event layer tooltips
                if(myNetworkSimulationTool._mapSgs.tooltips)
                    myNetworkSimulationTool._mapSgs.map.on('singleclick', async (e) => { await myNetworkSimulationTool._mapSgs.tooltips.BuildInfoTooltips(e); });

                // Reset cursor
                document.body.style.cursor = 'default';
            }
            else { // Active select
                // Remove event layer tooltips
                if(myNetworkSimulationTool._mapSgs.tooltips)
                    myNetworkSimulationTool._mapSgs.map.un('singleclick', myNetworkSimulationTool._mapSgs.tooltips.BuildInfoTooltips);

                // Active select edge
                myNetworkSimulationTool._mapSgs.map.on('singleclick', myNetworkSimulationTool._SelectEdge);

                // Change cursor
                document.body.style.cursor = 'pointer';
            }
        };

        buttonSelect.addEventListener('click', handleSelect, false);
        buttonSelect.addEventListener('touchstart', handleSelect, false);

        // -- Clean ---------------------------------------------------------------------------
        const buttonClean = document.createElement('li');
        buttonClean.className = "border-right";

        const buttonCleanContainer = document.createElement('a');
        buttonCleanContainer.setAttribute('title', 'Remover selecção');

        const buttonCleanContent = document.createElement('div');
        buttonCleanContent.className = 'menu-icon refresh';
        buttonCleanContent.innerHTML = '<i class="gpi gpi-apagar"></i>';

        buttonCleanContainer.appendChild(buttonCleanContent);
        buttonClean.appendChild(buttonCleanContainer);

        /**
         * Clean handle
         */
        const handleClean = function ()
        {
            // Clean all simulation object
            myNetworkSimulationTool._CleanSimulation(true);

            // Close btn selection cut
            myNetworkSimulationTool._CloseSelectionCut();
        };

        buttonClean.addEventListener('click', handleClean, false);
        buttonClean.addEventListener('touchstart', handleClean, false);

        // -- Submit --------------------------------------------------------------------------
        const buttonSubmit = document.createElement('li');

        const buttonSubmitContainer = document.createElement('a');
        buttonSubmitContainer.setAttribute('title', 'Simular');

        const buttonSubmitContent = document.createElement('div');
        buttonSubmitContent.className = 'menu-icon refresh';
        buttonSubmitContent.innerHTML = '<i class="fa fa-check modal-location-plant-button"></i>';

        buttonSubmitContainer.appendChild(buttonSubmitContent);
        buttonSubmit.appendChild(buttonSubmitContainer);

        /**
         * Submit handle location plant
         */
        const handleSubmit = function ()
        {
            // Execute simulation
            if(myNetworkSimulationTool._idEdgeSelected !== null && myNetworkSimulationTool._idEdgeSelected !== "")
            {
                // Clean all simulation object
                myNetworkSimulationTool._CleanSimulationResult();

                // Execute Simulation
                myNetworkSimulationTool._ExecuteSimulationRupture();
            }
            else
            {
                toastr["warning"]("Seleccione primeiro uma tubagem");
            }
        };

        buttonSubmit.addEventListener('click', handleSubmit, false);
        buttonSubmit.addEventListener('touchstart', handleSubmit, false);

        // -- Close ---------------------------------------------------------------------------
        const buttonClose = document.createElement('li');

        const buttonCloseContainer = document.createElement('a');
        buttonCloseContainer.setAttribute('title', 'Fechar simulação');

        const buttonCloseContent = document.createElement('div');
        buttonCloseContent.className = 'menu-icon refresh';
        buttonCloseContent.innerHTML = '<i class="fa fa-times modal-location-plant-button"></i>';

        buttonCloseContainer.appendChild(buttonCloseContent);
        buttonClose.appendChild(buttonCloseContainer);

        /**
         * close handle
         */
        const handleClose = function ()
        {
            // Clean simulation
            myNetworkSimulationTool._CleanSimulation(true);

            // Close btn selection cut
            myNetworkSimulationTool._CloseSelectionCut();

            // Close Toolbar
            $('#id-menubar-bottom-network-simulation-tool').toggle('ol-hidden');
        };

        buttonClose.addEventListener('click', handleClose, false);
        buttonClose.addEventListener('touchstart', handleClose, false);

        // -----------------------------------------------------------------------------------------
        // -- Build Menu ---------------------------------------------------------------------------
        // -----------------------------------------------------------------------------------------

        // -- Main menu bar network simulation tool -------------------------------------------------
        const mainMenuNetworkSimulationTool = document.createElement('ul');
        mainMenuNetworkSimulationTool.id = 'main-menu-network-simulation-tool';
        mainMenuNetworkSimulationTool.className = 'map-controls menubar-bottom';

        mainMenuNetworkSimulationTool.appendChild(buttonSelect);
        mainMenuNetworkSimulationTool.appendChild(buttonSubmit);
        mainMenuNetworkSimulationTool.appendChild(buttonClean);
        mainMenuNetworkSimulationTool.appendChild(buttonClose);

        // -- Menu panel network simulation tool --------------------------------------------------
        const menuPanelNetworkSimulationTool = document.createElement('div');
        menuPanelNetworkSimulationTool.appendChild(mainMenuNetworkSimulationTool);

        return menuPanelNetworkSimulationTool;
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Close selection cut btn
     */
    this._CloseSelectionCut = function()
    {
        if ($('#id-target-gpi-select-cut').hasClass('hold-button')) {
            myNetworkSimulationTool._mapSgs._utility.HoldButtonEffect('main-menu-network-simulation-tool', 'id-target-gpi-select-cut');

            // Remove select edge click
            myNetworkSimulationTool._mapSgs.map.un('singleclick', myNetworkSimulationTool._SelectEdge);

            // Active event layer tooltips
            if(myNetworkSimulationTool._mapSgs.tooltips)
                myNetworkSimulationTool._mapSgs.map.on('singleclick', async (e) => { await myNetworkSimulationTool._mapSgs.tooltips.BuildInfoTooltips(e); });

            // Reset cursor
            document.body.style.cursor = 'default';
        }
    }

    /**
     * Clean all object of the simulation
     * @param {bool} cleanIdEdge, on true clean edge identifier global variable
     */
    this._CleanSimulation = function(cleanIdEdge)
    {
        // Clean layer select source
        myNetworkSimulationTool._sourceLayerSelected.clear();

        // Clear highligh
        myNetworkSimulationTool._mapSgs.featureToHighLight.clear();

        // Clear point cut
        myNetworkSimulationTool._layerPointCut.getSource().clear();

        // Clean edge identifier selected
        if(cleanIdEdge)
            myNetworkSimulationTool._idEdgeSelected = null;

        // Clean Simulation result
        $('#id-offcanvas-search-result-expand').css('display', 'none');
        $('#id-offcanvas-search-result-expand-zone').css('display', 'none');
        $('#id-offcanvas-search-result-goto-zone')[0].className = "col col-md-4 col-xs-4";
        $('#id-offcanvas-search-result-clean-zone')[0].className = "col col-md-4 col-xs-4";
        $('#id-offcanvas-search-result-body').css("display", "block");
        $('#offcanvas-search-result-table-zone').css('display', 'block');
        $('#offcanvas-search-result-network-table-zone div').remove();
        $('#id-offcanvas-search-result-zone').addClass('ol-hidden');
        $('#id-offcanvas-search-result-body').addClass('ol-hidden');

        // hide title
        $('.offcanvas-search-result-table-zone-title').addClass('ol-hidden');

        // Hide offcanvas
        myNetworkSimulationTool._utility.ShowOpenCanvas3('offcanvas-search-result', false);

        // Write title
        $('#offcanvas-search-result .offcanvas-head header span').html("Resultado da Pesquisa");

        // Remove table result
        if (myNetworkSimulationTool._mapSgs.datatableSearchResult != null)
        {
            $('#offcanvas-search-result-table-zone.mCustomScrollbar').mCustomScrollbar('destroy');

            // Destroy table
            myNetworkSimulationTool._mapSgs.datatableSearchResult.destroy();

            // Empty table zone
            $('#offcanvas-search-result-table-zone').empty();

            // Recreate table node
            var tableSearch = $('<table id="offcanvas-search-result-table" cellspacing="0" width="100%"></table>');
            tableSearch.appendTo($('#offcanvas-search-result-table-zone'));
        }

        // Remove in close button the indication of a active simulation result
        $('#id-offcanvas-search-result-clean').attr("mode", "");
    }

    /**
     * Clean all object of the simulation
     * @param {bool} cleanIdEdge, on true clean edge identifier global variable
     */
    this._CleanSimulationResult = function (cleanIdEdge)
    {

        // Clear highligh
        myNetworkSimulationTool._mapSgs.featureToHighLight.clear();

        // Clean Simulation result
        $('#id-offcanvas-search-result-expand').css('display', 'block');
        $('#id-offcanvas-search-result-expand-zone').css('display', 'block');
        $('#id-offcanvas-search-result-goto-zone')[0].className = "col col-md-3 col-xs-3";
        $('#id-offcanvas-search-result-clean-zone')[0].className = "col col-md-2 col-xs-2";
        $('#id-offcanvas-search-result-body').css("display", "block");
        $('#offcanvas-search-result-table-zone').css('display', 'block');
        $('#offcanvas-search-result-network-table-zone div').remove();
        $('#id-offcanvas-search-result-zone').addClass('ol-hidden');
        $('#id-offcanvas-search-result-body').addClass('ol-hidden');

        // hide title
        $('.offcanvas-search-result-table-zone-title').addClass('ol-hidden');

        // Hide offcanvas
        myNetworkSimulationTool._utility.ShowOpenCanvas3('offcanvas-search-result', false);

        // Write title
        $('#offcanvas-search-result .offcanvas-head header span').html("Resultado da Pesquisa");

        // Remove table result
        if (myNetworkSimulationTool._mapSgs.datatableSearchResult != null) {
            $('#offcanvas-search-result-table-zone.mCustomScrollbar').mCustomScrollbar('destroy');

            // Destroy table
            myNetworkSimulationTool._mapSgs.datatableSearchResult.destroy();

            // Empty table zone
            $('#offcanvas-search-result-table-zone').empty();

            // Recreate table node
            var tableSearch = $('<table id="offcanvas-search-result-table" cellspacing="0" width="100%"></table>');
            tableSearch.appendTo($('#offcanvas-search-result-table-zone'));
        }

        // Remove in close button the indication of a active simulation result
        $('#id-offcanvas-search-result-clean').attr("mode", "");
    }

    /**
     * Execute simulation cut
     */
    this._ExecuteSimulationCut = function()
    {
        if(myNetworkSimulationTool._idEdgeSelected !== null && myNetworkSimulationTool._idEdgeSelected !== "")
        {
            // Start wait
            myNetworkSimulationTool._utility.ShowWait('offcanvas-map-spinner', true);

            // Clean
            $('#offcanvas-search-result .offcanvas-head header span').html("Resultado da Simulação");
            $('#offcanvas-search-result-network-doc-zone').hide();
            $('#id-search-result-detail-info-number-result span')[0].innerHTML = 0;
            $('#offcanvas-search-result-network-table-zone').empty();
            myNetworkSimulationTool._mapSgs._searchNetworkTool._resultRefDataSearch = {}

            $.ajax({
                type: 'GET',
                url: '/rest/app/NetworkSimulationTool/GetExecuteNetworkSimulationCut2?idEdge=' + myNetworkSimulationTool._idEdgeSelected,
                contentType: "application/json",
                dataType: 'json',
                async: true,
                success: function (data)
                {
                    if (data.error)
                    {
                        toastr["error"]("Erro na execução da simulação");
                    }
                    else
                    {
                        switch (data.result.status) {
                            case "SUCCESS":
                                var hashData = {};

                                // Check if any valve to close found
                                if(data.result.listValve != null && data.result.listValve.length === 0)
                                {
                                    toastr["warning"]("Nenhuma valvula encontrada");

                                    // Stop wait
                                    myNetworkSimulationTool._utility.ShowWait('offcanvas-map-spinner', false);

                                    return;
                                }

                                // List valve to close
                                var dataArray = [];
                                if (data.result.listValve.length > 0)
                                {
                                    $.map(data.result.listValve, function (value, i) {
                                        dataArray.push(value.id_valve);
                                    });

                                    hashData['valve'] = {
                                        array: dataArray,
                                        style: myNetworkSimulationTool._valveStyle,
                                        title: 'Válvulas a fechar'
                                    }
                                }

                                // List of pipe affected
                                dataArray = [];
                                if (data.result.listPipe.length > 0)
                                {
                                    $.map(data.result.listPipe, function (value, i) {
                                        dataArray.push(value.id_pipe);
                                    });
                                
                                    hashData['pipe'] = {
                                        array: dataArray,
                                        style: myNetworkSimulationTool._pipeStyle,
                                        title: 'Tubagem'
                                    };
                                }

                                // List of service pipe affected
                                dataArray = [];
                                if (data.result.listServicePipe.length > 0)
                                {
                                    $.map(data.result.listServicePipe, function (value, i) {
                                        dataArray.push(value.id_service_pipe);
                                    });
                                
                                    hashData['service_pipe'] = {
                                        array: dataArray,
                                        style: myNetworkSimulationTool._servicePipeStyle,
                                        title: 'Ramais'
                                    }
                                }
                                
                                // List of consumption point affected
                                dataArray = [];
                                if (data.result.listConsumptionPoint.length > 0)
                                {
                                    $.map(data.result.listConsumptionPoint, function (value, i) {
                                        dataArray.push(value.id_consumption_point);
                                    });
                                
                                    hashData['consumption_point'] = {
                                        array: dataArray,
                                        style: myNetworkSimulationTool._consumptionPointStyle,
                                        title: 'Pontos de Consumo'
                                    };
                                }

                                // High light all element
                                myNetworkSimulationTool._SetHighlighByHash(hashData);

                                // Show valve to close
                                //myNetworkSimulationTool._BuildValveInformation(listValve);

                                //if(listSource != null && listSource.length > 0)
                                //{
                                //    toastr["warning"]("Nenhuma valvula encontrada");
                                //}

                                toastr["success"]("Simulação processada com sucesso");
                                break;
                            default:
                                toastr["error"]("Erro na execução da simulação");
                                break;
                        }
                    }

                    // Stop wait
                    myNetworkSimulationTool._utility.ShowWait('offcanvas-map-spinner', false);
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro na execução da simulação");

                    // Stop wait
                    myNetworkSimulationTool._utility.ShowWait('offcanvas-map-spinner', false);
                }
            });
        }
    }

    /**
     * Execute simulation cut version 2
     */
    this._ExecuteSimulationRupture = function () {
        if (myNetworkSimulationTool._idEdgeSelected !== null && myNetworkSimulationTool._idEdgeSelected !== "") {
            // Start wait
            myNetworkSimulationTool._utility.ShowWait('offcanvas-map-spinner', true);

            // Clean
            $('#offcanvas-search-result .offcanvas-head header span').html("Resultado da Simulação");
            $('#offcanvas-search-result-network-doc-zone').hide();
            $('#id-search-result-detail-info-number-result span')[0].innerHTML = 0;
            $('#offcanvas-search-result-network-table-zone').empty();
            $('#id-offcanvas-search-result-expand-zone').css("display", "none");
            $('#id-offcanvas-search-result-goto-zone')[0].className = "col col-md-4 col-xs-4";
            $('#id-offcanvas-search-result-clean-zone')[0].className = "col col-md-4 col-xs-4";
            $('#id-offcanvas-search-result-clean').attr("mode", "simul");
            myNetworkSimulationTool._mapSgs._searchNetworkTool._resultRefDataSearch = {}

            $.ajax({
                type: 'GET',
                url: '/rest/app/NetworkSimulationTool/GetExecuteNetworkSimulationCut2?idEdge=' + myNetworkSimulationTool._idEdgeSelected,
                contentType: "application/json",
                dataType: 'json',
                async: true,
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro na execução da simulação");
                    }
                    else {
                        switch (data.result.status) {
                            case "SUCCESS":
                                var hashData = {};

                                // Check if any valve to close found
                                if (data.result.listValve != null && data.result.listValve.length === 0) {
                                    toastr["warning"]("Nenhuma valvula encontrada");

                                    // Stop wait
                                    myNetworkSimulationTool._utility.ShowWait('offcanvas-map-spinner', false);

                                    return;
                                }

                                // List valve to close
                                var dataArray = [];
                                if (data.result.listValve.length > 0) {
                                    $.map(data.result.listValve, function (value, i) {
                                        dataArray.push(value.id_valve);
                                    });

                                    hashData['valve'] = {
                                        array: dataArray,
                                        style: myNetworkSimulationTool._valveStyle,
                                        title: 'Válvulas a fechar'
                                    }
                                }

                                // List of pipe affected
                                dataArray = [];
                                if (data.result.listPipe.length > 0)
                                {
                                    $.map(data.result.listPipe, function (value, i) {
                                        dataArray.push(value.id_pipe);
                                    });
                                
                                    hashData['pipe'] = {
                                        array: dataArray,
                                        style: myNetworkSimulationTool._pipeStyle,
                                        title: 'Tubagem'
                                    };
                                }

                                // List of service pipe affected
                                dataArray = [];
                                if (data.result.listServicePipe.length > 0)
                                {
                                    $.map(data.result.listServicePipe, function (value, i) {
                                        dataArray.push(value.id_service_pipe);
                                    });
                                
                                    hashData['service_pipe'] = {
                                        array: dataArray,
                                        style: myNetworkSimulationTool._servicePipeStyle,
                                        title: 'Ramais'
                                    }
                                }

                                // List of consumption point affected
                                dataArray = [];
                                if (data.result.listConsumptionPoint.length > 0)
                                {
                                    $.map(data.result.listConsumptionPoint, function (value, i) {
                                        dataArray.push(value.id_consumption_point);
                                    });
                                
                                    hashData['consumption_point'] = {
                                        array: dataArray,
                                        style: myNetworkSimulationTool._consumptionPointStyle,
                                        title: 'Pontos de Consumo'
                                    };
                                }

                                // High light all element
                                myNetworkSimulationTool._SetHighlighByHash(hashData);

                                toastr["success"]("Simulação processada com sucesso");
                                break;
                            default:
                                toastr["error"]("Erro na execução da simulação");
                                break;
                        }
                    }

                    // Stop wait
                    myNetworkSimulationTool._utility.ShowWait('offcanvas-map-spinner', false);
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro na execução da simulação");

                    // Stop wait
                    myNetworkSimulationTool._utility.ShowWait('offcanvas-map-spinner', false);
                }
            });
        }
    }

    /**
     * High light all element of the simulation
     */
    this._SetHighlighByHash = function (data)
    {
        $.each(data, function (index, value)
        {
            var layerInfo = myNetworkSimulationTool._layerInfoElementToClose[index].layerInfo;
            myNetworkSimulationTool.SetFeaturesHighlightByArraySimulation(layerInfo, false, value.array, value.style, value.title);
        });
    };

    /**
     * Fill feature to layer highlight
     * @param {object} layerInfo, all information about the layer
     * @param {boolean} async, true for async geoserver call
     * @param {array} idsArray, array ids
     * @param {ol.Style} style, style
     * @param {string} tableName, table name
     */
    this.SetFeaturesHighlightByArraySimulation = function (layerInfo, async, idsArray, style, tableName)
    {
        // Get layer info
        myNetworkSimulationTool._layerCreateDatatable = layerInfo;

        // Array to string
        var idsString = idsArray.toString();

        var getFeatureUrl = layerInfo.geoserver + "/wfs";

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: async,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": layerInfo.workspace + ':' + layerInfo.layerName,
                "featureID": idsString,
                'srsName': myNetworkSimulationTool._mapSgs._settings.projection.code_,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR)
        {
            if (data.features)
            {
                if (data.features.length > 0)
                {
                    // Get all features
                    var arrayFeature = [];
                    for (var i = 0; i < data.features.length; i++)
                    {
                        let featureToRead = (new GeoJSON()).readFeatures(data)[i];
                        var styleElement = myNetworkSimulationTool._mapSgs._defaultHighlighStyles;
                        if (style)
                            styleElement = style;
                        featureToRead.setStyle(styleElement);
                        myNetworkSimulationTool._mapSgs.featureToHighLight.push(featureToRead);
                        arrayFeature.push(featureToRead);
                    }

                    // Set current features in overlay
                    myNetworkSimulationTool._mapSgs.layerHighlightOverlay.setSource(new VectorSource({ features: myNetworkSimulationTool._mapSgs.featureToHighLight, useSpatialIndex: true }));

                    // Go to Feature
                    myNetworkSimulationTool._mapSgs.map.getView().fit(myNetworkSimulationTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myNetworkSimulationTool._mapSgs.map.getSize() });
                    if (data.features.length == 1)
                    {
                        myNetworkSimulationTool._mapSgs.map.getView({
                            center: [myNetworkSimulationTool._mapSgs.layerHighlightOverlay.getSource().getExtent()[0], myNetworkSimulationTool._mapSgs.layerHighlightOverlay.getSource().getExtent()[1]]
                        });
                        myNetworkSimulationTool._mapSgs.map.getView().setZoom(myNetworkSimulationTool._mapSgs._ZoomSearch)
                    }

                    // Number of result
                    $('#id-search-result-detail-info-number-result span')[0].innerHTML = parseInt($('#id-search-result-detail-info-number-result span')[0].innerHTML) + data.features.length;

                    // Create table information
                    myNetworkSimulationTool._mapSgs._searchNetworkTool.CreateDatatables2(tableName, arrayFeature, myNetworkSimulationTool._layerCreateDatatable.id);
                }
            }
        });
    };

    /**
     * Select edge in map on click in map
     */
    this._SelectEdge = function(e)
    {
        // Get map
        var map = e.map;

        // Get the pixel selected
        var pixel = map.getEventPixel(e.originalEvent);

        // Get coordinate
        var coordinate = e.target.getCoordinateFromPixel(map.getEventPixel(e.originalEvent));

        // Clean layer select source
        myNetworkSimulationTool._sourceLayerSelected.clear();

        // Clean edge identifier selected
        myNetworkSimulationTool._idEdgeSelected = null;

        // Clean point cut
        myNetworkSimulationTool._layerPointCut.getSource().clear();

        // -- For each layer in the pixel -- WMS layer --
        map.forEachLayerAtPixel(pixel, function (layer, color)
        {
            if (
                myNetworkSimulationTool._IsLayerForSimulation(layer) &&
                (
                    (layer instanceof ImageLayer) || // && layer.getSource() instanceof ImageWMSSource) ||
                    (layer instanceof TileLayer) // && layer.getSource() instanceof TileWMSSource)
                )
            ) {
                myNetworkSimulationTool._SelectEdgeFromWMS(map, coordinate, pixel, e, layer, myNetworkSimulationTool._edgeStylesSelected);
            }
        },
        {
            hitTolerance: 10
        },
           function (layer) {
               if (!(layer.get('name') === undefined)) {
                   return myNetworkSimulationTool._IsLayerForSimulation(layer);
               }

               return false;
           }
        );

        // Add layer select to map
        var layer = null;
        if (myNetworkSimulationTool._layerSelectPosLayer === -1)
        {
            layer = new VectorLayer(
            {
                source: myNetworkSimulationTool._sourceLayerSelected,
                id: 'edgeForSimulation'
            });

            map.addLayer(layer);
            myNetworkSimulationTool._layerSelectPosLayer = map.getLayers().getArray().length - 1;
        }
        else {
            map.getLayers().getArray()[myNetworkSimulationTool._layerSelectPosLayer].setSource(myNetworkSimulationTool._sourceLayerSelected);
        }
    }

    /**
     * Check if layer is selected for simulation
     * @param {object} layer selected
     * @returns {boolean} true if layer is tooltips avaible
     */
    this._IsLayerForSimulation = function (layer)
    {
        var layerNameKey = layer.get('name');
        
        if( layerNameKey !== undefined)
        {
            var layerName = layerNameKey.split(':')[1];
            if(layerName !== undefined)
            {
                switch(layerName)
                {
                    case "aa_troco_tubagem":
                    case "vw_ws_pipe_line_1":
                    case "g_tubagens":
                        return true;
                    default:
                        return false;
                }
            }
        }

        return false;
    };

    /**
     * Select edge from wms layer feature
     * @param {Map} map, map
     * @param {object} coordinate, click map coordinates
     * @param {object} pixel, pixel from click mouse
     * @param {ol.MapBrowserEvent} evt the event.
     * @param {ol.layer} layer layer selected
     * @param {ol.source} source source of the layer
     * @param {object} styleSelect style of the selection
     */
    this._SelectEdgeFromWMS = function (map, coordinate, pixel, evt, layer, styleSelect)
    {
        var viewResolution = map.getView().getResolution();
        //myTooltips._layerNameKey = layer.get("name");
        //myTooltips._layerIdKey = layer.get("id");
        //if (myTooltips._layerNameKey === "") return;

        // Geoserver url
        var url = layer.getSource().getGetFeatureInfoUrl(
            evt.coordinate,
            viewResolution,
            map.getView().getProjection().getCode(),
            { 'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 10 }
        );

        if (url) {
            // Call Geoserver - Syncrone
            var parser = new GeoJSON();
            var request = $.ajax(
                {
                    method: "GET",
                    async: false,
                    url: url
                });

            // Geoserver Response
            request.done(function (data, textStatus, jqXHR)
            {
                if (data.features.length > 0)
                {
                    var featureLayer = parser.readFeatures(data['features'][0])[0];
                    var feature = featureLayer.clone();
                    feature.setId(featureLayer.getId()) + "_";
                    myNetworkSimulationTool._idEdgeSelected = featureLayer.getId().split(".")[1];
                    var featureSource = new Feature({
                        geometry: featureLayer.getGeometry(),
                        name: feature.getId()
                    });
                    featureSource.setStyle(styleSelect);
                    myNetworkSimulationTool._sourceLayerSelected.addFeature(featureSource);

                    // Build point of cut
                    var featurePointCut = new Feature({
                        geometry: new Point(coordinate),
                        name: "point-of-cut",
                        id: feature.getId() + "_point" 
                    });
                    myNetworkSimulationTool._layerPointCut.getSource().addFeature(featurePointCut);
                }
            });
        }
    };

    /**
     * Build valve to close information in map and in offcanvas
     * @param {array} listValve, list of all the valve to be close
     */
    this._BuildValveInformation = function(listValve)
    {
        // string of id's
        var idArray = listValve.map(function(item) {
            return myNetworkSimulationTool._layerInfoElementToClose.valve.layerName + "." + item['id_valve'].toString();
        });
        var idsString = idArray.toString();

        // Clear highligh
        myNetworkSimulationTool._mapSgs.featureToHighLight.clear();

        var getFeatureUrl = myNetworkSimulationTool._layerInfoElementToClose.valve.geoserver + "/wfs";

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: false,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": myNetworkSimulationTool._layerInfoElementToClose.valve.workspace + ':' + myNetworkSimulationTool._layerInfoElementToClose.valve.layerName,
                "featureID": idsString,
                'srsName': myNetworkSimulationTool._mapSgs._settings.projection.code_,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    var featureHash = {};
                    var columDefArrayExpand = [];
                    var columDefArrayExpandSize = [];
                    var columnDefArray = [];
                    var columnValueArray = [];
                    myNetworkSimulationTool._mapSgs._arraySearchLayerFeatureActive = [];
                    for (var i = 0; i < data.features.length; i++) {
                        var feature = (new GeoJSON()).readFeatures(data)[i];
                        myNetworkSimulationTool._mapSgs.featureToHighLight.push(feature);
                        myNetworkSimulationTool._mapSgs.featureToHighLight.getArray()[myNetworkSimulationTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(myNetworkSimulationTool._valveHighlighStyles);
                        var idPrimaryKey = feature.getId().split(".")[1];
                        featureHash[idPrimaryKey] = feature;

                        // Save feature valve
                        myNetworkSimulationTool._mapSgs._arraySearchLayerFeatureActive.push(feature);

                        // Build column info
                        var objRow = {};
                        for (var j = 0; j < Object.keys(feature.getProperties()).length; j++)
                        {
                            var columnName = Object.keys(feature.getProperties())[j];
                            if (columnName === "geometry")
                                continue;
                            var value = feature.getProperties()[columnName];
                            var columnProperties = myNetworkSimulationTool._mapSgs.layerTree.layerInfo.dict_layer_info[myNetworkSimulationTool._layerInfoElementToClose.valve.layerInfo.id].list_column.filter(obj => {
                                return obj.column_name === columnName
                            })[0];

                            // If value is a system date, format string
                            //if (new Date(value) != 'Invalid Date' && isNaN(value))
                            if (columnProperties) {
                                if (columnProperties.column_type == 'xsd:date-time')
                                    value = myNetworkSimulationTool._utility.TransformDateServerInDateTime(value);

                                objRow[columnName] = value;
                                if (columDefArrayExpandSize[columnName]) {
                                    if (value) {
                                        var valueSize = value.toString().length;
                                        columDefArrayExpandSize[columnName] = (valueSize > columDefArrayExpandSize[columnName]) ? valueSize : columDefArrayExpandSize[columnName];
                                    }
                                }
                                else {
                                    if (value)
                                        columDefArrayExpandSize[columnName] = value.toString().length;
                                    else
                                        columDefArrayExpandSize[columnName] = 30; // If fist empty
                                }
                                if (i === 0) {
                                    var columnSearchResult = myNetworkSimulationTool._mapSgs._settings.treeMap.dict_layer_info[myNetworkSimulationTool._layerInfoElementToClose.valve.layerInfo.id].list_column.find(c => c.column_name === columnName).search_result;
                                    var visible = myNetworkSimulationTool._mapSgs._settings.treeMap.dict_layer_info[myNetworkSimulationTool._layerInfoElementToClose.valve.layerInfo.id].list_column.find(c => c.column_name === columnName).visible;
                                    var columnPrettyName = myNetworkSimulationTool._mapSgs._settings.treeMap.dict_layer_info[myNetworkSimulationTool._layerInfoElementToClose.valve.layerInfo.id].list_column.find(c => c.column_name === columnName).pretty_name;
                                    var searchResultOrder = myNetworkSimulationTool._mapSgs._settings.treeMap.dict_layer_info[myNetworkSimulationTool._layerInfoElementToClose.valve.layerInfo.id].list_column.find(c => c.column_name === columnName).search_result_order;

                                    if (columnSearchResult) {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px',
                                            'search_order': searchResultOrder
                                        });
                                    } else {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false,
                                            'search_order': 0
                                        });
                                    }
                                    if (visible) {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px'
                                        });
                                    }
                                    else {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false
                                        });
                                    }
                                }
                            }
                        }
                        // Order columns by search order
                        columnDefArray = columnDefArray.sort((a, b) => (a.search_order > b.search_order) ? 1 : -1);

                        // Add primary key value
                        objRow["id_primary_key"] = idPrimaryKey;

                        // Add array row
                        columnValueArray.push(objRow);
                    }

                    // Add primary key to array
                    columnDefArray.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });
                    columDefArrayExpand.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });

                    // Add size to column in array expand
                    for (let i = 0; i < columDefArrayExpand.length; i++) {
                        var objDef = columDefArrayExpand[i];
                        if (objDef.width) {
                            if (columDefArrayExpandSize[objDef.data] > 50)
                                objDef.width = columDefArrayExpandSize[objDef.data].toString() + "px";
                            else
                                objDef.width = "50px";
                            columDefArrayExpand[i] = objDef;
                        }
                    };

                    // Show information of valve in offcanvas
                    myNetworkSimulationTool._utility.ShowOpenCanvas3('offcanvas-search-result', true);

                    // Make datatable list
                    myNetworkSimulationTool._mapSgs.InitSearchResultTable(myNetworkSimulationTool._layerInfoElementToClose.valve.workspace, myNetworkSimulationTool._layerInfoElementToClose.valve.layerName, myNetworkSimulationTool._layerInfoElementToClose.valve.layerInfo.id, featureHash, columnDefArray, columDefArrayExpand, columnValueArray, myNetworkSimulationTool._mapSgs.DetailElement, true, "Válvulas a fechar");

                    // Remove hide in offcanvas search result information
                    $('#id-offcanvas-search-result-zone').removeClass('ol-hidden');
                    $('#id-offcanvas-search-result-body').removeClass('ol-hidden');

                    // Go to Feature
                    if(myNetworkSimulationTool._mapSgs.layerHighlightOverlay.getSource().getFeatures().length == 1) {
                        var feature = myNetworkSimulationTool._mapSgs.layerHighlightOverlay.getSource().getFeatures()[0];
                        var featureType = feature.getGeometry().getType();
                        switch(featureType) {
                            case "MultiPoint":
                            case "Point":
                                myNetworkSimulationTool._mapSgs.map.getView().fit(myNetworkSimulationTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myNetworkSimulationTool._mapSgs.map.getSize(), maxZoom: 12, duration: 1000  });
                                break;
                            default:
                                myNetworkSimulationTool._mapSgs.map.getView().fit(myNetworkSimulationTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myNetworkSimulationTool._mapSgs.map.getSize(), duration: 1000  });
                        }
                    }
                    else
                        myNetworkSimulationTool._mapSgs.map.getView().fit(myNetworkSimulationTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myNetworkSimulationTool._mapSgs.map.getSize(), duration: 1000  });
                }
            }
        });
    
    }

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------
    // -- end event -------------------------------------------------------------------------------
}


/**
 * Init network simulation tool
 * @param {object} mapSgs, map object
 */
NetworkSimulationTool.prototype.Init = function (mapSgs)
{

    if (!this._toolInitialize)
    {
        this._toolInitialize = true;

        var this_ = this;

        // Set map info
        this._mapSgs = mapSgs;

        // Get layer information of element to close
        var valveWorkspace            = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "NETWORK_SIMULATION_TOOL", "LAYER_VALVE_INFO", "WORKSPACE");
        var valveLayerName            = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "NETWORK_SIMULATION_TOOL", "LAYER_VALVE_INFO", "LAYER_NAME");
        var valveGeoserver            = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "NETWORK_SIMULATION_TOOL", "LAYER_VALVE_INFO", "GEOSERVER");
        var valveColumnGeomName       = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "NETWORK_SIMULATION_TOOL", "LAYER_VALVE_INFO", "COLUMN_GEOM_NAME");
        var sourceWorkspace           = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "NETWORK_SIMULATION_TOOL", "LAYER_SOURCE_INFO", "WORKSPACE");
        var sourceLayerName           = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "NETWORK_SIMULATION_TOOL", "LAYER_SOURCE_INFO", "LAYER_NAME");
        var sourceGeoserver           = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "NETWORK_SIMULATION_TOOL", "LAYER_SOURCE_INFO", "GEOSERVER");
        var sourceColumnGeomName      = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "NETWORK_SIMULATION_TOOL", "LAYER_SOURCE_INFO", "COLUMN_GEOM_NAME");
        var pipeLayerName             = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "NETWORK_SIMULATION_TOOL", "LAYER_PIPE_INFO", "LAYER_NAME");
        var servicePipeLayerName      = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "NETWORK_SIMULATION_TOOL", "LAYER_SERVICE_PIPE_INFO", "LAYER_NAME");
        var consumptionPointLayerName = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "NETWORK_SIMULATION_TOOL", "LAYER_CONSUMPTION_POINT", "LAYER_NAME");

        this._layerInfoElementToClose = {
            valve: {
                workspace: (valveWorkspace===undefined)?"":valveWorkspace.value,
                layerName: (valveLayerName===undefined)?"":valveLayerName.value,
                geoserver: (valveGeoserver===undefined)?"":valveGeoserver.value,
                columnGeomName: (valveColumnGeomName===undefined)?"":valveColumnGeomName.value,
                layerInfo: this._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName((valveLayerName === undefined) ? "" : valveLayerName.value)[0],
                style: this._valveStyle
            },
            source: {
                workspace: (sourceWorkspace===undefined)?"":sourceWorkspace.value,
                layerName: (sourceLayerName===undefined)?"":sourceLayerName.value,
                geoserver: (sourceGeoserver===undefined)?"":sourceGeoserver.value,
                columnGeomName: (sourceColumnGeomName===undefined)?"":sourceColumnGeomName.value,
                layerInfo: this._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName((sourceLayerName === undefined) ? "" : sourceLayerName.value)[0],
                style: null
            },
            pipe: {
                layerInfo: this._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName((pipeLayerName === undefined) ? "" : pipeLayerName.value)[0],
                layerName: (pipeLayerName === undefined) ? "" : pipeLayerName.value,
                styler: this._pipeStyle
            },
            service_pipe: {
                layerInfo: this._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName((servicePipeLayerName === undefined) ? "" : servicePipeLayerName.value)[0],
                layerName: (servicePipeLayerName === undefined) ? "" : servicePipeLayerName.value,
                style: this._servicePipeStyle
            },
            consumption_point: {
                layerInfo: this._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName((consumptionPointLayerName === undefined) ? "" : consumptionPointLayerName.value)[0],
                layerName: (consumptionPointLayerName === undefined) ? "" : consumptionPointLayerName.value,
                style: this._consumptionPointStyle
            }
        };

        // Layer for draw cut point in edge select
        this._layerPointCut = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._stylePointCut,
            name: 'point_cut'
        });
        this._mapSgs.map.addLayer(this._layerPointCut);
    }
}